module.exports = __webpack_public_path__ + "static/media/start_point_300.15e1711e.png";